import {type RefObject, useEffect} from 'react';
import {getChekinRuntimeSettings} from '../lib/runtimeSettings';

type UseScrollFrameIntoViewOptions = {
  behavior?: ScrollBehavior;
  elementRef?: RefObject<HTMLElement | null>;
};

export function useScrollFrameIntoView(
  active?: boolean,
  options: UseScrollFrameIntoViewOptions = {},
) {
  const {behavior = 'smooth', elementRef} = options;

  useEffect(() => {
    const sdkWindow = window;

    if (!active || !getChekinRuntimeSettings()?.autoHeight) {
      return;
    }

    const frame = sdkWindow.chekinCustomFrame;

    if (!frame) {
      return;
    }

    const parentWindow = window.parent;

    const scrollToElement = () => {
      const frameRect = frame.getBoundingClientRect();

      if (elementRef?.current) {
        const elementRect = elementRef.current.getBoundingClientRect();
        const elementCenterInFrame = elementRect.top + elementRect.height / 2;
        const elementCenterInParent = frameRect.top + elementCenterInFrame;
        const targetScroll =
          parentWindow.scrollY + elementCenterInParent - parentWindow.innerHeight / 2;

        parentWindow.scrollTo({
          top: Math.max(0, targetScroll),
          behavior,
        });
        return;
      }

      frame.scrollIntoView({behavior, block: 'start'});
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToElement);
    });
  }, [active, behavior, elementRef]);
}
